import { render, staticRenderFns } from "./CustomerAdminList.vue?vue&type=template&id=5d8fa264&"
import script from "./CustomerAdminList.vue?vue&type=script&lang=js&"
export * from "./CustomerAdminList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports